<div
    [hidden]="hideInput"
    class="avi-textarea-container clr-wrapper"
>
    <ng-content></ng-content>
    <ng-content select="textarea"></ng-content>
</div>
